import * as angular from "angular";
import * as _ from "lodash";
import {SplitService} from "../services/split-service.service";

angular
  .module('bringoz.admin.commons')
  .filter('omsPackagesVolume', packageVolume);

function packageVolume($filter, splitService: SplitService) {
  return function packageVolumeFilter(itemLines, enableUnitDisplay) {
    const countAsTotal = splitService.getPackageVolumeIsTotal();

    const itemsVolumeSum = _.reduce(itemLines, (sum, packageRef) => {
      const volume = (packageRef.volume || packageRef.dimensions?.cube);
      return volume ? (countAsTotal ? (volume + sum) : (volume * (packageRef.count || 1) + sum)) : sum;
    }, 0);
    return itemsVolumeSum ? $filter('bringozVolume')(itemsVolumeSum, enableUnitDisplay) : '--';
  }
}
